import { cancelReplanScheduleEvents } from "../../../../../../../../../../api/kehrblatt/schedule-events"
import type { CancelAppointmentsOperations } from "../actions/cancelAppointments"

export const cancelAppointmentsOperations: CancelAppointmentsOperations = {
  cancelAppointments: cancelReplanScheduleEvents,
}
